//GET SCHEDULES FROM API
export const REPORTS_MAIN_GET_SCHEDULE_REPORT_SETUP = "REPORTS_MAIN_GET_SCHEDULE_REPORT_SETUP"; 
export const REPORTS_MAIN_GET_SCHEDULE_REPORT_SETUP_RESULT = "REPORTS_MAIN_GET_SCHEDULE_REPORT_SETUP_RESULT"; 

export const REPORTS_MAIN_DELETE_SCHEDULE_REPORT = "REPORTS_MAIN_DELETE_SCHEDULE_REPORT"; 
export const REPORTS_MAIN_DELETE_SCHEDULE_REPORT_RESULT = "REPORTS_MAIN_DELETE_SCHEDULE_REPORT_RESULT"; 
